// extracted by mini-css-extract-plugin
export default {"icon":"Icon__icon___PyN-N","look":"Icon__look___2GhMT","melee":"Icon__melee___jquvA","get":"Icon__get___G-fzG","info":"Icon__info___zhWAG"};